import type { LangCode } from '@learnforge/i18n';
import type { TrigKey } from './keys';
import { en } from './en';
import { ar } from './ar';
import { bn } from './bn';
import { de } from './de';
import { es } from './es';
import { fa } from './fa';
import { fr } from './fr';
import { gu } from './gu';
import { hi } from './hi';
import { id } from './id';
import { it } from './it';
import { ja } from './ja';
import { ko } from './ko';
import { mr } from './mr';
import { nl } from './nl';
import { pa } from './pa';
import { pl } from './pl';
import { pt } from './pt';
import { ro } from './ro';
import { ru } from './ru';
import { sw } from './sw';
import { ta } from './ta';
import { te } from './te';
import { th } from './th';
import { tl } from './tl';
import { tr } from './tr';
import { uk } from './uk';
import { ur } from './ur';
import { vi } from './vi';
import { zh } from './zh';

// Non-English locales are partial (keys missing fall back to English at runtime).
// The cast satisfies createI18n's type, which marks the whole language as optional
// but treats present entries as full records. The runtime handles missing keys safely.
export const locales: Partial<Record<LangCode, Record<TrigKey, string>>> & {
  en: Record<TrigKey, string>;
} = {
  en,
  ro,
  zh: zh as Record<TrigKey, string>,
  hi: hi as Record<TrigKey, string>,
  es: es as Record<TrigKey, string>,
  fr: fr as Record<TrigKey, string>,
  ar: ar as Record<TrigKey, string>,
  bn: bn as Record<TrigKey, string>,
  pt: pt as Record<TrigKey, string>,
  ru: ru as Record<TrigKey, string>,
  ur: ur as Record<TrigKey, string>,
  id: id as Record<TrigKey, string>,
  de: de as Record<TrigKey, string>,
  ja: ja as Record<TrigKey, string>,
  mr: mr as Record<TrigKey, string>,
  te: te as Record<TrigKey, string>,
  tr: tr as Record<TrigKey, string>,
  ta: ta as Record<TrigKey, string>,
  vi: vi as Record<TrigKey, string>,
  tl: tl as Record<TrigKey, string>,
  ko: ko as Record<TrigKey, string>,
  fa: fa as Record<TrigKey, string>,
  sw: sw as Record<TrigKey, string>,
  it: it as Record<TrigKey, string>,
  pa: pa as Record<TrigKey, string>,
  gu: gu as Record<TrigKey, string>,
  th: th as Record<TrigKey, string>,
  pl: pl as Record<TrigKey, string>,
  uk: uk as Record<TrigKey, string>,
  nl: nl as Record<TrigKey, string>,
};

export type { TrigKey } from './keys';
